import { useRef, createRef } from 'react'

export default function useMultiRef() {
  const multiRef = useRef(null)
  if (null === multiRef.current) {
    multiRef.current = Array.prototype.map.call(arguments, value => {
      const ref = createRef()
      ref.current = value
      return ref
    })
  }
  return multiRef.current
}
